import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "range-facet",
  class RangeFacet extends WYATTElement {
    constructor() {
      super();

      this.highInput = this.querySelector("[data-template-element='high']");
      this.lowInput = this.querySelector("[data-template-element='low']");
    }

    get name() {
      return this.facet.name || "filter.ss_price";
    }

    connectedCallback() {
      this.facet = this.querySelector("[data-facet]");

      const facetData = JSON.parse(this.facet.dataset.facet);

      this.setNames();
      this.setValues(facetData);
      this.setChecked(facetData.active);

      this.facet.addEventListener("change", this.handleChange.bind(this));

      this.publish(WYATT.PubSub.events.updateSearchHistory);
    }

    handleClearAll() {
      this.uncheck();
    }

    handleChange() {
      this.setChecked(this.facet.checked);

      this.publish(WYATT.PubSub.events.updateSearchHistory);
    }

    setNames() {
      const baseName = this.name;
      this.highInput.name = `${baseName}.high`;
      this.lowInput.name = `${baseName}.low`;
    }

    setValues({ high, low }) {
      this.highInput.value = high ?? "";
      this.lowInput.value = low ?? "";
    }

    setChecked(active) {
      this.facet.checked = active;
      this.highInput.disabled = !active;
      this.lowInput.disabled = !active;
    }
  },
);
